module.exports = __webpack_public_path__ + "static/img/oogaverse.7c08194.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partnerships/oogaverse.png
// module id = KYkV
// module chunks = 1